<template>
  <div class="section-container position--relative">
    <section>
      <slot name="content"></slot>
    </section>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.section-container section {
  z-index: 1;
  position: relative;
  margin: 8px 0;
  padding: 16px 16px;
  box-shadow: 6px 6px 16px 6px rgba(32, 35, 36, 0.08);
  border-radius: 12px;
  margin-bottom: 20px;
}
</style>
